import { component } from 'picoapp';
import Drawer from 'utils/drawer';

const SENTINEL = '#eu-guarantee';
const MIN_ZOOM = 1;
const MAX_ZOOM = 8;
const ZOOM_STEP = 1.5;

export default component((node) => {
  const drawer = Drawer(node);
  const viewport = node.querySelector('[data-eu-guarantee-viewport]');
  const graphic = node.querySelector('[data-eu-guarantee-graphic]');

  let zoom = MIN_ZOOM;
  let previousBodyOverflow = '';

  const clamp = (value) => Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, value));

  const lockBodyScroll = () => {
    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  };

  const unlockBodyScroll = () => {
    document.body.style.overflow = previousBodyOverflow;
  };

  const setZoom = (next) => {
    if (!viewport || !graphic) return;

    const target = clamp(next);
    if (target === zoom) return;

    zoom = target;
    graphic.style.width = `${zoom * 100}%`;
  };

  const resetZoom = () => {
    if (!viewport || !graphic) return;

    zoom = MIN_ZOOM;
    graphic.style.width = '100%';
    viewport.scrollTo(0, 0);
  };

  const hydrateGraphic = () => {
    if (!graphic) return;

    const { src } = graphic.dataset;
    if (!src || graphic.getAttribute('src') === src) return;

    graphic.setAttribute('src', src);
  };

  const openFromTrigger = (event) => {
    event.preventDefault();
    drawer.open();
  };

  drawer.on('open', () => {
    hydrateGraphic();
    lockBodyScroll();
  });

  drawer.on('close', () => {
    unlockBodyScroll();
    resetZoom();
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('a[href]');
    if (!trigger || !trigger.getAttribute('href')?.includes(SENTINEL)) return;

    openFromTrigger(event);
  });

  node.addEventListener('click', (event) => {
    const { target } = event;

    const zoomButton = target.closest?.('[data-eu-guarantee-zoom]');
    if (!zoomButton || !node.contains(zoomButton)) return;

    const action = zoomButton.dataset.euGuaranteeZoom;

    if (action === 'in') setZoom(zoom * ZOOM_STEP);
    else if (action === 'out') setZoom(zoom / ZOOM_STEP);
    else resetZoom();
  });

  if (window.location.hash === SENTINEL) {
    drawer.open();
  }
});
